module.exports = __webpack_public_path__ + "static/media/foto4.c2a37f5c.png";